export default {
  AdvancePaymentInvest: 1,
  AdvanceInvest: 2,
};
